export enum ServiceInfoType {
    BOOK_SERVICE = 'book-service',
    RENTAL_CAR = 'rental-car',
    TIRES = 'tires',
    WASHES = 'washes',
    INSURANCE = 'insurance',
    FUEL = 'fuel',
    ROAD_SERVICE = 'road-service',
    CAR_POLICY = 'car-policy',
    CAR_CHANGE = 'car-change',
    VEHICLE_USAGE = 'vehicle-usage',
    VEHICLE_INSPECTION = 'vehicle-inspection',
    CUSTOMER_SERVICE = 'customer-service',
}
